import styled from 'styled-components';

const HomeSectionImage = styled.img`
  position: absolute;
  bottom: -56px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    width: 192px;
    top: 10px;
    right: -80px;
    bottom: unset;
    left: unset;
    transform: unset;
  }
`;

export default HomeSectionImage;
